/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useState } from 'react';
import { Actionable, Dropdown, Text } from '@az/starc-ui';
import styles from './styles.module.scss';
import { useBvPixelTracking } from '../../hooks/useBvPixelTracking';

type SortOption = {
  label: string;
  value: string;
};

type SortByDropdownProps = {
  sortOptions: SortOption[];
  onSortChange?: (value: string) => void;
};

const SortByDropDown = ({ sortOptions, onSortChange }: SortByDropdownProps) => {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(sortOptions[0]);
  const { trackEvent } = useBvPixelTracking();

  const handleSortChange = (option: SortOption) => {
    setSelectedOption(option);
    onSortChange?.(option.value);
    trackEvent?.('Sort By', 'Click', 'Filter', option.value);
    setOpen(false);
  };

  return (
    <Dropdown
      placement="bottom-end"
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      className={styles.reviewDropdown}
    >
      <Dropdown.Button className={styles.dropdownButton}>
        <Text className={styles.dropdownButtonText}>{selectedOption?.label || 'Sort By'}</Text>
      </Dropdown.Button>
      <Dropdown.Content>
        {open && (
          <div>
            <ul>
              {sortOptions.map((option) => (
                <li key={option.value} className={styles.sortByDropDownOptions}>
                  <Actionable onClick={() => handleSortChange(option)}>
                    <Text className={styles.sortOption}>{option.label}</Text>
                  </Actionable>
                  {option !== sortOptions[sortOptions.length - 1]}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Dropdown.Content>
    </Dropdown>
  );
};

export default SortByDropDown;
